import { useEffect, useState } from 'react'
import useMap from 'tennders-transactions/hooks/useMap'
import useOffer from 'tennders-market/offer/hooks/useOffer'
import useOffers from 'tennders-market/offer/hooks/useOffers'
import useTransaction from 'tennders-transactions/hooks/useTransaction'
import useSocket from 'tennders-common/hooks/useSocket'
import { useToast } from 'tennders-common/hooks/useToast'
import { calculateRouteDistance } from 'tennders-stracture/libs/utils'
import useTranslation from 'next-translate/useTranslation'
import { REFRESH_TYPES } from 'tennders-common/stores/socket/action'
import useValidation from 'tennders-common/hooks/useValidation'
import useTruckSubmitRules from 'tennders-market/truck/hooks/useTruckSubmitRules'

export const withSendOffer = (WrappedComponent) => (props) => {
  const { t } = useTranslation()
  const { transaction } = useTransaction()
  const [submitting, setsubmitting] = useState(false)
  const { toastSuccess, toastError } = useToast()
  const { mapForm, setMapForm, selectedRoute } = useMap()
  const { selectedDistance, setRouteSelectable, setEditMode } = useMap()
  const [step, setstep] = useState(0)
  const [pickup, setpickup] = useState({})
  const { setRefresh } = useSocket()
  const { validate } = useValidation()
  const { fetchOffers } = useOffers()
  const { pickupRouteRules } = useTruckSubmitRules()

  const {
    selectedOffer,
    counterMode,
    savingRoute,
    makeOffer,
    errors,
    setOfferErrors
  } = useOffer()

  const [form, setform] = useState({
    ...mapForm,
    paymentTerm: selectedOffer?.lastOffer?.paymentTerms
  })

  const reset = () => setstep(0)

  const onChange = (k, v) => setform({ ...form, [k]: v })

  const sendBid = async () => {
    setsubmitting(true)

    const pickupValidated = validate(mapForm.pickupRoute, pickupRouteRules)
    const deliveryValidated = validate(mapForm.deliveryRoute, pickupRouteRules)

    if (!pickupValidated.validated && !deliveryValidated.validated) {
      setsubmitting(false)
      setOfferErrors({
        ...errors,
        pickupRoute: pickupValidated?.errors,
        deliveryRoute: deliveryValidated?.errors
      })
      return toastError(t('validation:fill_pickup_delivery_date'))
    }
    if (!pickupValidated.validated) {
      setsubmitting(false)
      setOfferErrors({
        ...errors,
        pickupRoute: pickupValidated?.errors
      })
      return toastError(t('validation:fill_pickup_date'))
    }
    if (!deliveryValidated.validated) {
      setsubmitting(false)
      setOfferErrors({
        ...errors,
        deliveryRoute: deliveryValidated?.errors
      })
      return toastError(t('validation:fill_delivery_date'))
    }

    setTimeout(async () => {
      const params = {
        ...form,
        ...mapForm,
        counterTo: selectedOffer?.id,
        emptyKm: form.emptyKm,
        truckPickupRoute: pickup,
        route: selectedRoute?.route,
        routeDetails: selectedRoute?.routeDetails,
        saveCallback: selectedRoute?.save
      }
      if (selectedRoute?.distance || selectedDistance) {
        params.distance = selectedRoute?.distance || selectedDistance
      }
      let response
      try {
        response = await makeOffer(transaction, params)
        if (response?.id) {
          toastSuccess('Offer is sent')
          setstep(3)
          if (counterMode) {
            await fetchOffers(transaction)
            setTimeout(() => {
              setRefresh(`${REFRESH_TYPES.OFFER}-${response?.id}`)
            }, 50)
          //  await fetchOffers(transaction);
            // await refreshTransaction();
          } else {
            // await fetchOffers(transaction);
          }
          //  fetchPrompts();
          setTimeout(() => {
            setRefresh('all')
          }, 1400)
          // refreshTransaction();
        }
      } catch (e) {
        throw new Error(e)
      }
      setsubmitting(false)
    }, 100)
  }

  useEffect(() => {
    setstep(0)
    if (transaction) {
      setEditMode(true)
    } else {
      setEditMode(false)
    }
  }, [transaction])

  useEffect(() => {
    if (Object.keys(pickup).length > 0) {
      calculateRouteDistance([transaction?.pickupRoute, pickup], (result) => {
        if (result?.distance) {
          setform({ ...form, emptyKm: result?.distance })
          setMapForm({ ...mapForm, emptyKm: result?.distance })
        }
      })
    }
  }, [pickup])

  useEffect(() => {
    if (mapForm?.pickupRoute && Object.keys(mapForm?.pickupRoute).length > 0) {
      calculateRouteDistance([transaction?.pickupRoute, mapForm?.pickupRoute], (result) => {
        if (result?.distance) {
          setform({ ...form, emptyKm: result?.distance })
          setMapForm({ ...mapForm, emptyKm: result?.distance })
        }
      })
    }
  }, [mapForm?.pickupRoute])

  useEffect(() => {
    if (step > 1) {
      setRouteSelectable(false)
    }
  }, [step])

  useEffect(() => {
    const f = { ...form }
    if (selectedOffer?.id) {
      f.counterTo = selectedOffer?.id
    }
    if (selectedOffer?.paymentTerms) {
      f.paymentTerm = selectedOffer?.paymentTerms
    }

    setform(f)
  }, [selectedOffer])

  return (
    <WrappedComponent
      sendBid={sendBid}
      transaction={transaction}
      onChange={onChange}
      savingRoute={savingRoute}
      step={step}
      setstep={setstep}
      pickup={pickup}
      setpickup={setpickup}
      reset={reset}
      form={form}
      errors={errors}
      selectedDistance={selectedDistance}
      submitting={submitting}
      {...props}
    />
  )
}
